// Asal: Warenkorb – Fortschrittsbalken mit Prämienstufen und „Passt dazu“ (Ein-Klick-Hinzufügen). Ohne Bibliotheken.
(() => {
  const euro = cents => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  // Stufen kommen ausschließlich aus dem Orangen Hub (Einstellungen → Prämien).
  let hubTiers = null;
  if (window.AsalPlace) window.AsalPlace.load().then(r => { if (Array.isArray(r.rewards)) { hubTiers = r.rewards.map(t => ({ a: Number(t.amount), t: t.label })).filter(t => t.a > 0).sort((x, y) => x.a - y.a); refresh(); } }).catch(() => {});

  const renderTiers = total => {
    document.querySelectorAll('[data-asal-tiers]').forEach(box => {
      // Eine Quelle: nur Stufen aus dem Hub. Ohne Hub-Antwort oder ausgeschaltet bleibt der Balken weg.
      const tiers = hubTiers || [];
      box.hidden = !tiers.length;
      if (!tiers.length) return;
      const max = tiers[tiers.length - 1].a * 100;
      const next = tiers.find(t => total < t.a * 100);
      box.querySelector('[data-asal-tiers-fill]').style.width = Math.min(100, (total / max) * 100) + '%';
      const msg = box.querySelector('[data-asal-tiers-msg]');
      if (next) msg.innerHTML = `Noch <strong>${euro(next.a * 100 - total)}</strong> bis: ${next.t.replace(/</g, '&lt;')}`;
      else msg.innerHTML = '<strong>Geschafft!</strong> Alle Prämien sind dabei.';
      const steps = box.querySelector('[data-asal-tiers-steps]');
      steps.replaceChildren(...tiers.map(t => {
        const li = document.createElement('li');
        li.style.left = (t.a * 100 / max) * 100 + '%';
        li.className = total >= t.a * 100 ? 'is-done' : '';
        li.innerHTML = '<span></span><b></b>';
        li.querySelector('b').textContent = euro(t.a * 100).replace(',00', '');
        li.title = t.t;
        return li;
      }));
    });
  };

  const hideOwned = items => {
    const ids = new Set(items.map(i => String(i.product_id)));
    document.querySelectorAll('.asal-upsell__item').forEach(el => { el.hidden = ids.has(el.dataset.productId); });
    document.querySelectorAll('[data-asal-upsell]').forEach(box => {
      box.hidden = !box.querySelector('.asal-upsell__item:not([hidden])');
    });
  };

  const refresh = async cart => {
    try {
      const c = cart && cart.items ? cart : await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      renderTiers(c.total_price);
      hideOwned(c.items);
    } catch (e) { /* ohne Warenkorbdaten bleibt alles wie gerendert */ }
  };

  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-asal-upsell-add]');
    if (!b) return;
    b.disabled = true;
    b.textContent = '…';
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.asalUpsellAdd), quantity: 1 }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
      if (document.querySelector('#CartPageForm') || location.pathname === '/cart') location.reload();
    } catch (err) {
      b.textContent = 'Nicht verfügbar';
      return;
    }
    b.textContent = '✓';
  });

  ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(ev => document.addEventListener(ev, e => setTimeout(() => refresh(e.detail && e.detail.cart), 400)));
  refresh();
})();
